module.exports = __webpack_public_path__ + "img/Speaker=Ravi Ravindran.d60d72d1.png";